import { render, staticRenderFns } from "./prod_layer.vue?vue&type=template&id=763370e6&scoped=true&"
import script from "./prod_layer.vue?vue&type=script&lang=js&"
export * from "./prod_layer.vue?vue&type=script&lang=js&"
import style0 from "./prod_layer.vue?vue&type=style&index=0&id=763370e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763370e6",
  null
  
)

export default component.exports